var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"arrow-nav",class:`arrow-nav-${this.type}`,on:{"click":_vm.onClick}},[_c('i',{staticClass:"fa",class:`fa-chevron-${this.type}`}),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }